import { render } from "./PortailMobile.vue?vue&type=template&id=3871b605&scoped=true&ts=true"
import script from "./PortailMobile.vue?vue&type=script&lang=ts"
export * from "./PortailMobile.vue?vue&type=script&lang=ts"

import "./PortailMobile.vue?vue&type=style&index=0&id=3871b605&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3871b605"]])

export default __exports__